import { render } from "./ForgotPasswordForm.vue?vue&type=template&id=2f00f40e"
import script from "./ForgotPasswordForm.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ForgotPasswordForm.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script